export class Locale {
  constructor(public language: string, public country: string, public defaultLanguage = false, public region: 'EU' | 'US' = 'EU') {}

  /**
   * @example de-de
   */
  toString() {
    return `${this.language}-${this.country}`;
  }

  /**
   * @example de-DE
   */
  get RFC5646() {
    return `${this.language}-${this.country.toUpperCase()}`;
  }
}
